// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textbutton {
  color: var(--primary-color-main);
  cursor: pointer;
}
.textbutton:hover {
  color: var(--primary-color-dark);
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/TextButton.scss"],"names":[],"mappings":"AAAA;EACI,gCAAA;EACA,eAAA;AACJ;AAAI;EACI,gCAAA;AAER","sourcesContent":[".textbutton {\r\n    color: var(--primary-color-main);\r\n    cursor: pointer; \r\n    &:hover{\r\n        color: var(--primary-color-dark);\r\n      }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
